import type { UpdateInvoicesBillingStatusResponse } from '@vy/api-definition';
import type { InvoiceBillingStatus } from '@vy/types';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { invalidateInvoicesQueries } from '../../utils/query-invalidation';

type mutationInputType = {
  invoiceStatus: InvoiceBillingStatus;
  invoiceIds: string[];
};

export function useUpdateInvoicesBillingStatuses(
  options?: UseMutationOptions<UpdateInvoicesBillingStatusResponse, unknown, mutationInputType>,
) {
  const queryClient = useQueryClient();

  const mutationFn = (variables: mutationInputType) => {
    const api = getPrivateApi();

    return api.updateInvoicesBillingStatuses({
      updateInvoicesBillingStatusesRequest: {
        invoicesByNewStatus: {
          [variables.invoiceStatus]: variables.invoiceIds,
        },
      },
    });
  };

  return useMutation(mutationFn, {
    onSuccess: async () => {
      await invalidateInvoicesQueries(queryClient);
    },
    ...options,
  });
}
